import React from "react";
import { connect } from "react-redux";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import CreateQuestion from "../../element/Question/CreateQuestion/CreateQuestion";
import { Droppable } from "react-beautiful-dnd";
import { Col, Row } from "reactstrap";
import ElementWrapper from "../../../components/element/ElementWrapper/ElementWrapper";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { AddElement } from "../../../components/UI/List/AddElement/AddElement";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import MessageOutlinedIcon from "@material-ui/icons/MessageOutlined";
import "../../../components/UI/List/ElementItem/ElementItem.css";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import ElementDropItem from "../../../components/editor/ElementDropItem/ElementDropItem";

class QuestionElements extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      collapse: false,
      simpleModal: false,
      contentModal: false,
      copyElement: null,
      useBase: null,
      list: null,
      optionQuestionIsOpen: false,
      textQuestionIsOpen: false
    };
  }
  attach = element => {
    const { dispatch, form } = this.props;
    const adjusted = { ...element, formId: form.formId };
    dispatch(formActions.attach(adjusted));
    this.reset();
  };
  reset = () => {
    this.setState({
      copyElement: null,
      useBase: null,
      simpleModal: false,
      contentModal: false
    });
  };
  componentDidUpdate(prevProps) {
    if (
      prevProps.form !== this.props.form &&
      this.props.form !== undefined &&
      this.props.elements !== undefined
    ) {
      let result = [];
      this.props.elements.map((e, index) => {
        if (
          e.type === elementConstants.QUESTION &&
          !this.props.form.formElements.find(el => {
            return el.id === e.id && el.type === e.type;
          })
        ) {
          result.push(e);
        }
      });
      this.setState({ list: result });
    }
  }
  preCreate = () => {
    this.setState({ contentModal: true });
  };
  toggleCollapse = area => {
    this.setState({ [area]: !this.state[area] });
  };

  preAttach = element => {
    this.setState({
      copyElement: () => this.copy(element),
      useBase: () => this.attach(element),
      simpleModal: true
    });
  };

  toggle() {
    this.setState(state => ({ collapse: !state.collapse }));
  }
  filterActiveQuestions = () => {
    const filtered = [];
    const { form, elements } = this.props;
    if (
      elements !== undefined &&
      form !== undefined &&
      form.formElements !== undefined
    ) {
      elements.map(el => {
        if (
          !form.formElements.find(fel => {
            return (
              fel.id === el.id &&
              fel.props !== null &&
              fel.props.name === el.props.name &&
              fel.props.type === el.props.type
            );
          }) &&
          el.type === elementConstants.QUESTION
        ) {
          filtered.push(el);
        }
      });
    }
    return filtered;
  };
  render() {
    const { elements, cms } = this.props;
    const { contentModal } = this.state;
    const filteredElements = this.filterActiveQuestions();
    const displayLang = cms.languageCode;
    if (elements === undefined) return null;
    return (
      <div className="element-list">
        <AddElement create={this.preCreate} />
        {elements && elements.length > 0 ? (
          <React.Fragment>
            {elements.filter(p => p.props.type === 'Text').length > 0 ? <div style={{ margin: " 0px 2px" }}>
              <div
                style={{
                  color: "#222",
                  fontWeight: "600",
                  fontSize: "10px",
                  color: "rgb(81, 97, 103)",
                  textTransform: "uppercase",
                  borderBottom: "0px !important",
                  wordBreak: "break-all",
                  paddingBottom: "8px"
                }}
              >
                <SystemLabel name="TextQuestions" />
              </div>
            </div> : null}
            <Droppable droppableId={"sidebar-question"}>
              {provided => (
                <div
                  ref={provided.innerRef}
                  className="content-container-drop"
                  style={{
                    overflow: "auto",
                    overflowX: "hidden",
                    display: "inline-block"
                  }}
                >
                  <Row style={{ margin: "0px", width: "225px" }}>
                    {filteredElements
                      .filter(el => {
                        return el.props.type === "Text"
                      })
                      .map((e, index) => {
                        return (
                          <Col key={index} style={{ padding: "0px", paddingBottom: "5px" }}>
                            <ElementWrapper
                              key={index}
                              id={`${e.type}:${e.id}`}
                              index={index}
                            >
                              <ElementDropItem
                                name={
                                  e.props.labels &&
                                  e.props.labels.find(l => {
                                    return l.languageCode === displayLang;
                                  }).text
                                }
                                row={true}
                                userLabel={true}
                                inherit={e.eventId != cms.eventId}
                                draggableId={`${e.type}:${e.id}`}
                                icon={
                                  <MessageOutlinedIcon
                                    style={{
                                      fontSize: "40px",
                                      padding: "5px 0px"
                                    }}
                                  />
                                }
                              />
                            </ElementWrapper>
                          </Col>
                        );
                      })}
                  </Row>
                </div>
              )}
            </Droppable>
            {elements.filter(p => p.props.type === 'Option').length > 0 ? <div style={{ margin: " 0px 2px" }}>
              <div
                style={{
                  color: "#222",
                  fontWeight: "600",
                  fontSize: "10px",
                  color: "rgb(81, 97, 103)",
                  textTransform: "uppercase",
                  borderBottom: "0px !important",
                  wordBreak: "break-all",
                  paddingBottom: "8px"
                }}
              >
                <SystemLabel name="OptionQuestion" />
              </div>
            </div> : null}
            <Droppable droppableId={"sidebar-question"}>
              {provided => (
                <div
                  ref={provided.innerRef}
                  className="content-container-drop"
                  style={{ overflow: "auto", overflowX: "hidden" }}
                >
                  <Row style={{ margin: "0px", width: "225px" }}>
                    {filteredElements
                      .filter(el => {
                        return el.props.type === "Option"
                      })
                      .map((e, index) => {
                        return (
                          <Col style={{ padding: "0px", paddingBottom: "5px" }}>
                            <ElementWrapper
                              key={index}
                              id={`${e.type}:${e.id}`}
                              index={index}
                            >
                              <ElementDropItem
                                name={
                                  e.props.labels &&
                                  e.props.labels.find(l => {
                                    return l.languageCode === displayLang;
                                  }).text
                                }
                                row={true}
                                inherit={e.eventId != cms.eventId}
                                draggableId={`${e.type}:${e.id}`}
                                userLabel={true}
                                icon={
                                  <CheckBoxOutlinedIcon
                                    style={{
                                      fontSize: "40px",
                                      padding: "5px 0px"
                                    }}
                                  />
                                }
                              />
                            </ElementWrapper>
                          </Col>
                        );
                      })}
                  </Row>
                </div>
              )}
            </Droppable>
          </React.Fragment>
        ) : null}
        <CreateQuestion
          isOpen={contentModal}
          action1={this.state.copyElement}
          action2={this.reset}
          title="Create new question"
          actionLabel="Create"
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    elements: state.element.elements,
    cElement: state.element,
    alert: state.alert,
    form: state.form,
    event: state.event,
    cms:state.cms
  };
}

export default connect(mapStateToProps)(QuestionElements);
